import { hubConnection } from "signalr-no-jquery";
import { useEffect } from "react";
import { connectionState } from "typings/signalr-no-jquery";
import { useSelector } from "react-redux";
import { isAuthenticatedSelector } from "./selectors";

const subscriptions: NewMessageHandler[] = [];

const connection = hubConnection(undefined, {
   qs: `pathname=${encodeURI(window.location.pathname)}`
});

const hub = connection.createHubProxy("commonHub");
hub.on("newMessage", (data: LSWebUI.Hubs.NewMessageModel) => {
   LiquidSpaceConfig.DEBUG && console.log("newMessage", data);

   subscriptions.forEach(onNewMessage => {
      onNewMessage(data);
   });
});

export interface NewMessageHandler {
   (data: LSWebUI.Hubs.NewMessageModel): void;
}
interface UseCommonHubProperties {
   onNewMessage: NewMessageHandler;
}

export function useCommonHub({ onNewMessage }: UseCommonHubProperties) {
   const isAuthenticated = useSelector(isAuthenticatedSelector);
   useEffect(() => {
      if (isAuthenticated) {
         if (subscriptions.length == 0 && connection.state == connectionState.disconnected) {
            connection.start();
         }

         subscriptions.push(onNewMessage)

         return () => {
            subscriptions.splice(subscriptions.indexOf(onNewMessage), 1);
            if (subscriptions.length == 0) {
               connection.stop();
            }
         }
      }
   }, [onNewMessage, isAuthenticated]);


   return {};
}